import { render, staticRenderFns } from "./FullPageSlideDots.vue?vue&type=template&id=d7a531dc&scoped=true"
import script from "./FullPageSlideDots.vue?vue&type=script&lang=js"
export * from "./FullPageSlideDots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a531dc",
  null
  
)

export default component.exports